var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isNormal)?_c('div',[_c('Banner'),_c('SearchAddress',{staticClass:"my-10"}),_c('CouponIsland'),_c('PromotedChains'),_c('POIs')],1):_vm._e(),_c('Restaurants'),(_vm.isNormal)?_c('BizsBanner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }